<template>
	<div style="flex: 1;display: flex;flex-direction: column;">
		<div class="device-mobile" v-if="isMobile" style="flex: 1;background: #F5F5F5;">
			<div class="newsCenter">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent>
						<span @click="toTopImg()">首页</span>
						<span class="arrow">></span>
						<span @click="barClick(0)">公司业绩</span>
						<span class="arrow">></span>
						<span @click="type = 0" v-if="list[count] && list[count].menuName">{{ list[count].menuName
							}}</span>
					</div>
				</div>
				<div class="tabbar">
					<div class="item" @click="barClick(index)" :class="{ active: count == index }"
						v-for="(item, index) in list">
						<div class="txt">{{ item.menuName }}</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="body" v-if="type == 0">
					<div class="newsItem" v-for="(item, index) in newsList" @click="newsItem(item)" v-if="false">
						<img :src="webImg + item.contentImg + imgCut(200, 150)" alt="" v-if="item.contentImg"
							@dragstart.prevent>
						<div class="newsItem-content">
							<!-- <div class="title" >我就爱覅偶尔今晚五九二九覅哦啊微积分我减肥我就爱佛i就哇哦</div> -->
							<div class="title txt-ellipsis-2" v-html="item.contentTitle"></div>
							<div class="content txt-ellipsis-2" v-if="item.contentImg && search"
								v-html="item.contentDetails">
							</div>
							<div class="content txt-ellipsis-2" v-if="!item.contentImg && search"
								v-html="item.contentDetails">
							</div>
							<div class="content txt-ellipsis-2" v-if="item.contentImg && !search"> {{
								clearBlank(getSimpleText(item.contentDetails)) }}
							</div>
							<div class="content txt-ellipsis-2" v-if="!item.contentImg && !search">{{
								clearBlank(getSimpleText(item.contentDetails))
							}}
							</div>
							<div class="time">{{ item.createTime }}</div>
						</div>
					</div>
					<div v-if="true" class="newsItem" v-for="(item, index) in newsList" @click="newsItem(item)">
						<div class="newsItem-content" style="display: flex;flex-direction: row;width: 100%;align-items: center;">
							<div class="title txt-ellipsis-2" style="flex: 1;">
								{{ item.contentTitle }}
							</div>
							<div style="margin-left: 10px;font-weight: bold;color: #004EA1;font-size: 14px;">查看</div>
							<!-- <div class="time">{{ item.createTime }}</div> -->
						</div>
					</div>
				</div>
				<div class="body" v-if="type == 1">
					<div class="detail">
						<div style="margin: 0 auto;font-weight: 600;font-size: 0.466667rem;text-align: center;"
							v-html="title">

						</div>
						<div
							style="margin: 0 auto;font-weight: 400;font-size: 0.373333rem;text-align: center;color: #333333;margin-top: 0.533333rem;">
							发布时间:{{ createTime.slice(0, 10) }}</div>
						<div style="margin: 0 auto;height: 0.053333rem;background: #c1c1c1;margin-top: 20px;">
						</div>
						<div v-html="formatRichText(contentDetails)"
							style="padding-bottom: 0.533333rem;font-size: 0.213333rem;text-align: justify;"></div>
					</div>
					<div>
						<!-- 						<div style="position: absolute;bottom: -45px;display: flex;width:925px; padding: 0 10px;box-sizing: border-box;"> -->
						<div class="upNews" @click="upNewsClick()"
							v-if="flippingList[0] && flippingList[0].contentTitle">
							<span class="upNewsIcon">上一篇</span>
							<span class="upNewsText" v-if="flippingList[0] && flippingList[0].contentTitle">{{
								flippingList[0].contentTitle }}</span>
						</div>
						<div class="upNews" @click="nextNewsClick()"
							v-if="flippingList[2] && flippingList[2].contentTitle">
							<span class="upNewsIcon">下一篇</span>
							<span class="upNewsText" v-if="flippingList[2] && flippingList[2].contentTitle">{{
								flippingList[2].contentTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="newsCenter">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent> <span @click="toTopImg()"
							style="cursor: pointer;">首页</span>
						<span style="color: black;">></span><span @click="barClick(0)">公司业绩</span><span
							style="color: black;">></span><span @click="type = 0"
							v-if="list[count] && list[count].menuName">{{
								list[count].menuName }}</span>
					</div>
				</div>
				<div class="main">
					<div class="left">
						<div class="top">公司业绩</div>
						<div v-for="(item, index) in list" class="bar" :class="{ bar1: count == index }"
							@click="barClick(index)">{{
								item.menuName
							}}</div>

					</div>
					<div class="right" v-if="type == 0" style="padding-bottom: 0;">
						<!-- <div class="newsItem" v-for="(item, index) in newsList" @click="newsItem(item)"
							>
							<img :src="webImg + item.contentImg + imgCut(200, 150)" alt="" v-if="item.contentImg"
								@dragstart.prevent>

							<div
								style="height: 150px;display: flex;flex-direction: column;justify-content: space-around;">
								<div class="title" v-html="item.contentTitle"></div>
								<div class="content" v-if="item.contentImg && search" v-html="item.contentDetails">
								</div>
								<div class="content" v-if="!item.contentImg && search" v-html="item.contentDetails">
								</div>
								<div class="content" v-if="item.contentImg && !search"> {{
									clearBlank(getSimpleText(item.contentDetails)) }}
								</div>
								<div class="content" v-if="!item.contentImg && !search" style="width: 885px">{{
									clearBlank(getSimpleText(item.contentDetails))
								}}
								</div>
								<div class="time">{{ item.createTime }}</div>
							</div>
						</div> -->

						<div class="table-header" style="display: flex; width: 885px;height: 50px;align-items: center;border-bottom: 1px dashed #e5e5e5;margin: 20px 20px 0;cursor: pointer;background: #F5F5F5;padding: 0 10px;box-sizing: border-box;">
							<div class="title"
								style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow: ellipsis;width: 750px;">
								业绩项目
							</div>
							<div class="look" style="margin-left: auto;font-weight: bold;">操作</div>
						</div>
						<div
							style="display: flex; width: 885px;height: 50px;align-items: center;border-bottom: 1px dashed #e5e5e5;margin: 0 20px 0;cursor: pointer;padding: 0 10px;box-sizing: border-box;"
							v-for="(item, index) in newsList" @click="newsItem(item)">
							<div class="title"
								style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow: ellipsis;width: 750px;">
								{{ item.contentTitle }}
							</div>
							<div class="look" style="margin-left: auto;font-weight: bold;color: #004EA1;">查看</div>
						</div>

						<div style="height: 130px;display: flex;align-items: center;justify-content: center;"
							v-if="type == 0 && newsList.length > 0">
							<el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize"
								@current-change="handleCurrentChange">
							</el-pagination>
						</div>
					</div>
					<div class="right" style="padding: 10px;position: relative;" v-if="type == 1">
						<div style="margin: 0 auto;font-weight: 600;font-size: 20px;text-align: center;" v-html="title">

						</div>
						<div
							style="margin: 0 auto;font-weight: 400;font-size: 14px;text-align: center;color: #333333;margin-top: 20px;">
							发布时间:{{ createTime.substring(0, 10) }}</div>
						<div style="width: 900px;margin: 0 auto;height: 2px;background: #c1c1c1;margin-top: 10px;">
						</div>
						<div v-html="formatRichText(contentDetails)" style="padding-bottom: 20px;text-align: justify;"></div>
						<div style="width: 900px;margin: 0 auto;height: 60px;background: #fff;"></div>
						<div
							style="position: absolute;bottom: -45px;display: flex;width:925px; padding: 0 10px;box-sizing: border-box;">
							<div class="upNews" @click="upNewsClick()"
								v-if="flippingList[0] && flippingList[0].contentTitle">
								<span class="upNewsIcon">上一篇</span>
								<span class="upNewsText" v-if="flippingList[0] && flippingList[0].contentTitle">{{
									flippingList[0].contentTitle }}</span>
							</div>
							<div class="upNews" @click="nextNewsClick()"
								v-if="flippingList[2] && flippingList[2].contentTitle">
								<span class="upNewsIcon">下一篇</span>
								<span class="upNewsText" v-if="flippingList[2] && flippingList[2].contentTitle">{{
									flippingList[2].contentTitle }}</span>
							</div>
						</div>
						<!-- <div style="width:925px;height: 20px;position: absolute;bottom: 0;"></div> -->
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import {
	performanceCategory,
	performanceProjectListByCategoryId,
	performanceProjectInfo,
	performanceProjectNavigation
} from '../api/api'
export default {
	name: 'aboutUsTemplate',
	data() {
		return {
			list: [], //二级菜单数组
			parentId: this.$route.query.parentId || '', //二级菜单数组id
			count: 0,
			newsList: [],
			type: 0,
			pageNum: 1,
			// pageSize: 5,
			pageSize: 10,
			total: 0,
			menuId: '',
			newsId: '',
			contentDetails: '', //详情
			search: '',
			title: '',
			createTime: '',
			flippingList: []
		}
	},
	created() {
		if (this.$route.query.contentId) {
			this.type = 1
		}
		this.getList() //二级菜单数组
	},
	mounted() {
		if (this.isMobile) {
			this.$bus.$on('reachBottom', data => {
				if (this.type == 0) {
					if (this.newsList.length && this.pageNum * this.pageSize < this.total) {
						this.pageNum++;
						this.getContentPage();
					} else {
						this.$message({
							message: '没有更多了~',
							center: true,
							offset: window.screen.height / 2
						});
					}
				}

			});
		}

	},
	beforeDestroy() {
		this.$bus.$off('reachBottom');
	},
	watch: {
		$route(to, from) {
			this.count = to.query.num
			this.barClick(to.query.num)
		},

	},
	methods: {
		getSimpleText(html) {
			const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
			const arrEntities = {
				'lt': '<',
				'gt': '>',
				'nbsp': ' ',
				'amp': '&',
				'quot': '"',
				'ldquo': '“',
				'mdash': '—',
				"rdquo": '”'
			};
			return html.replace(re1, '').replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/ig, function (all, t) {
				return arrEntities[t];
			});
		},
		//二级菜单数组
		getList() {
			performanceCategory().then(res => {
				res.data.forEach(item => {
					item.menuId = item.id
					item.menuName = item.title
				})
				this.list = res.data
				if (this.$route.query.num) {
					if (this.$route.query.search) {
						this.search = this.$route.query.search
					}
					this.count = this.$route.query.num || 0
					this.menuId = this.list[this.count].menuId
					this.getContentPage()
				} else {
					this.menuId = this.list[0].menuId
					this.getContentPage()
				}
			})
		},
		getContentPage() {
			performanceProjectListByCategoryId(this.pageNum, this.pageSize, this.menuId).then(res => {
				res.data.forEach(item => {
					item.contentTitle = item.title
					item.contentDetails = item.content
					item.contentImg = item.coverImage
				})
				res.data.forEach
				if (!this.isMobile) {
					this.newsList = res.data;
				} else {
					if (this.pageNum == 1) {
						this.newsList = res.data;
					} else {
						this.newsList = this.newsList.concat(res.data);
					}
				}
				this.total = res.total
				if (this.search && this.search.length > 0) {
					const reg = `/${this.search}/g`;
					this.newsList.forEach((item) => {
						console.log(item, 'item.contentTitle');
						item.contentTitle = item.contentTitle.replace(
							eval(reg),
							"<span style='color: red;'>" + this.search + "</span>"
						);
						if (item.contentDetails) {
							item.contentDetails = this.clearBlank(this.getSimpleText(item
								.contentDetails))
							item.contentDetails = item.contentDetails.replace(
								eval(reg),
								"<span style='color: red;'>" + this.search + "</span>"
							);
						}
					});
				}
				if (this.$route.query.contentId) {
					this.type = 1
					this.newsList.forEach(item => {
						if (item.id == this.$route.query.contentId) {
							this.contentDetails = item.contentDetails
							this.title = item.contentTitle
							this.createTime = item.createTime

						}
					});
					this.$route.query.contentId = ''
				}
				// this.snckData = res.data
			})
		},
		barClick(index) {
			this.count = index
			this.search = ''
			this.menuId = this.list[index].id
			this.pageNum = 1
			this.getContentPage()
			this.type = 0
		},
		newsItem(item) {
			this.type = 1
			this.newsId = item.id
			this.getflipping()
		},
		handleCurrentChange(e) {
			this.pageNum = e
			this.getContentPage()
			console.log(`当前页: ${e}`);
		},
		formatRichText(html) { //控制富文本图片大小
			let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				// match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				// match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
				match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
					'max-width:100%;');
				return match;
			});
			newContent = newContent.replace(/<br[^>]*\/>/gi, '');

			newContent = newContent.replace(/\<img/gi,
				'<img style="max-width:95%;height:auto;display:inline-block;margin:10rpx auto;text-indent: 0;"');


			return newContent;
		},
		//首页
		toTopImg() {
			this.$router.push({
				path: '/home',
				query: {
					index: 0
				}
			})
		},
		getflipping() {
			console.log(this.newsId, 'this.newsId');
			performanceProjectInfo(this.newsId).then(res => {
				res.data.contentDetails = res.data.content
				res.data.contentTitle = res.data.title
				res.data = [null,res.data,null]
				console.log(res, 'flipping');
				this.contentDetails = res.data[1].contentDetails
				this.title = res.data[1].contentTitle
				this.createTime = res.data[1].createTime
				// this.flippingList = res.data
			})
			performanceProjectNavigation(this.newsId).then(res => {
				console.log(res, 'navigation');
				if (res.data.previous) {
					res.data.previous.contentDetails = res.data.previous.content
					res.data.previous.contentTitle = res.data.previous.title
				}
				if (res.data.next) {
					res.data.next.contentDetails = res.data.next.content
					res.data.next.contentTitle = res.data.next.title
				}
				res.data = [res.data.previous,null,res.data.next]
				this.flippingList = res.data
			})
		},
		//
		upNewsClick() {
			this.newsId = this.flippingList[0].id
			this.getflipping()
			document.documentElement.scrollTop = 0;
		},
		nextNewsClick() {
			this.newsId = this.flippingList[2].id
			this.getflipping()
			document.documentElement.scrollTop = 0;
		}
	}
}
</script>

<style scoped lang="scss">
.device-mobile {
	width: 100vw;
	background: #F5F5F5;

	.newsCenter {
		width: 9.466667rem;
		// display: flex;
		// justify-content: center;
		margin: auto;

		.navigation {
			width: 100%;

			// background: #F5F5F5;
			// padding: 0 0.333333rem;
			.navigationItem {
				display: flex;
				align-items: center;
				padding-top: 0.36rem;
				// height: 1.066667rem;
				color: #1979b7;
				font-size: 0.333333rem;

				.arrow {
					color: #030303;
					margin: 0 0.133333rem;
				}

				img {
					width: 0.333333rem;
					height: 0.333333rem;
					margin-right: 0.133333rem;
				}
			}
		}

		.tabbar {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			align-items: center;

			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				margin-right: 0.4rem;

				&.active {
					.txt {
						font-size: 0.453333rem;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: bold;
						color: #000000;
					}

					.line {
						display: block;
					}
				}

				.txt {
					font-size: 0.4rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
				}

				.line {
					position: absolute;
					bottom: -0.266667rem;
					display: none;
					margin-top: 0.213333rem;
					width: 1.2rem;
					height: 0.053333rem;
					background: #007CC3;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
				}
			}
		}

		.body {
			width: 100%;

			.detail {
				width: 9.466667rem;
				box-sizing: border-box;
				padding: 0.266667rem;
				background: #FFFFFF;
			}

			.upNews {
				display: flex;
				align-items: center;
				font-size: 14px;
				margin: 0.266667rem 0;

				.upNewsIcon {
					height: 30px;
					display: inline-block;
					width: 56px;
					flex-basis: 56px;
					height: 30px;
					text-align: center;
					line-height: 30px;
					background-color: #0175C2;
					color: #fff;
					border-radius: 6px;
					margin-right: 20px;
					position: relative;
				}

				.upNewsText {
					width: 360px;
					color: #666;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
				}

				.upNewsIcon::after {
					content: "";
					display: block;
					position: absolute;
					width: 0;
					height: 0;
					border-left: 5px solid #0175C2;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					right: 0;
					top: 50%;
					transform: translate(100%, -50%);
				}
			}

			.newsItem {
				width: 100%;
				// height: 190px;
				display: flex;
				background: #FFFFFF;
				box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
				box-sizing: border-box;
				padding: 0.266667rem;
				margin-bottom: 0.266667rem;

				img {
					flex-shrink: 0;
					width: 2.666667rem;
					height: 2rem;
					margin-right: 0.266667rem;
					display: flex;
					align-items: center;
					object-fit: cover;
				}

				.newsItem-content {
					// flex: 1;
					display: flex;
					flex-direction: column;

					// width: 200px;
					.title {
						font-size: 0.346667rem;
						font-family: Microsoft YaHei-Bold, Microsoft YaHei;
						font-weight: bold;
						color: #333333;
					}

					.content {
						margin-top: 0.266667rem;
						font-size: 0.293333rem;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #000000;
					}

					.time {
						margin-top: 0.4rem;
						font-size: 0.293333rem;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #004EA1;

					}
				}
			}
		}
	}
}

.device-pc {
	.newsCenter {
		width: 100vw;
		// display: flex;
		// justify-content: center;
		background: #F5F5F5;
		padding-bottom: 60px;

	}

	.main {
		display: flex;
		width: 1300px;
		padding-top: 25px;
		margin: 0 auto;

	}

	.left {
		// background: #FFFFFF;

		.top {
			width: 270px;
			height: 64px;
			background: url('../assets/bannerImg.png') no-repeat;
			background-size: 100%;
			font-size: 26px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.bar {
			width: 270px;
			height: 48px;
			background: #FFFFFF;
			border-bottom: 1px solid #EDEDED;
			font-size: 18px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #333333;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			cursor: pointer;
		}

		.bar1 {
			font-size: 18px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #0175C2;
			border-bottom: 1px solid #0175C2;
			border-bottom: 1px solid #0175C2;
		}
	}

	.right {
		width: 925px;

		margin-left: 10px;
		min-height: 600px;
		background: #FFFFFF;
		box-sizing: border-box;


		.upNews {
			width: 850px;
			display: flex;
			align-items: center;
			cursor: pointer;

			font-size: 14px;

			.upNewsIcon {
				height: 30px;
				display: inline-block;
				width: 56px;
				flex-basis: 56px;
				height: 30px;
				text-align: center;
				line-height: 30px;
				background-color: #0175C2;
				color: #fff;
				border-radius: 6px;
				margin-right: 20px;
				position: relative;
			}

			.upNewsText {
				width: 360px;
				color: #666;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
			}

			.upNewsIcon::after {
				content: "";
				display: block;
				position: absolute;
				width: 0;
				height: 0;
				border-left: 5px solid #0175C2;
				border-top: 5px solid transparent;
				border-bottom: 5px solid transparent;
				right: 0;
				top: 50%;
				transform: translate(100%, -50%);
			}
		}

		.newsItem {
			width: 885px;
			height: 190px;
			border-bottom: 1px solid #EDEDED;
			box-sizing: border-box;
			display: flex;
			margin-top: 28px;
			margin-left: 20px;
			cursor: pointer;

			// align-items: center;
			img {
				width: 200px;
				height: 150px;
				margin-right: 20px;
				display: flex;
				align-items: center;
				object-fit: cover;
			}


		}

		.title {
			font-size: 16px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			// font-weight: bold;
			color: black;
			text-size-adjust: none;
			font-family: '微软雅黑';
			// height: 26px;
		}

		.content {
			// text-indent: 30px;
			color: #999;
			font-size: 14px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			width: 650px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		.time {
			font-size: 16px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			// font-weight: bold;
			color: #999;
			// height: 21px;

		}
	}

	.navigation {
		// width: 1210px;
		width: 100vw;
		background: #fff;
		display: flex;
		align-items: center;


		.navigationItem {
			width: 1300px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			// margin-top: 15px;
			height: 36px;
			line-height: 36px;
			margin-bottom: 20px;
			padding-top: 15px;
			box-sizing: border-box;
			color: #1979b7;
			font-size: 20px;
			cursor: pointer;
		}

		img {
			width: 20px;
			height: 20px;
			margin-right: 7px;

		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/performance.vue